// extracted by mini-css-extract-plugin
export default {"skip":"Link_skip__RRfFy"};